import { useContext, useMemo } from "react";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";

import { LanguageContext } from "./LanguageContext";

const LanguageDirectionWrapper = (props) => {
  const { languageDir } = useContext(LanguageContext);

  // Memoize Emotion caches to avoid recreating them and re-injecting styles on theme updates
  const rtlCache = useMemo(() => createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin],
  }), []);

  const ltrCache = useMemo(() => createCache({
    key: 'mui',
  }), []);

  return (
    <CacheProvider value={languageDir === "ltr" ? ltrCache : rtlCache}>
      {props.children}
    </CacheProvider>
  )
}

export { LanguageDirectionWrapper }